(function () {
  if (!window.IS_PRODUCTION) return;

  var conversionId = 'AW-17934920734';
  var gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + conversionId;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  gtag('js', new Date());
  gtag('config', conversionId);

  window.GOOGLE_ADS_CONVERSIONS = {
    // Promo floating CTA retired; keep labels commented for potential reuse.
    // promoTrigger: 'AW-17934920734/BvqrCOLQnb4cEJ7YhOhC',
    // modalUnlock: 'AW-17934920734/m__XCInBi74cEJ7YhOhC',
    couponCheckout: 'AW-17934920734/zPpvCJCLob4cEJ7YhOhC',
    reserveYourDrive: 'AW-17934920734/SIgjCPm2s8McEJ7YhOhC',
    joinFbGroup: 'AW-17934920734/GafnCLOo9tEcEJ7YhOhC'
  };

  window.reportGoogleAdsConversion = function (sendTo, onComplete, params) {
    var didComplete = false;
    var complete = function () {
      if (didComplete) return;
      didComplete = true;
      if (typeof onComplete === 'function') onComplete();
    };

    if (!sendTo || typeof gtag !== 'function') {
      complete();
      return;
    }

    var conversionParams = {
      send_to: sendTo,
      event_callback: complete
    };
    if (params) {
      if (typeof params.value === 'number') conversionParams.value = params.value;
      if (params.currency) conversionParams.currency = params.currency;
      if (params.transaction_id) conversionParams.transaction_id = params.transaction_id;
    }
    gtag('event', 'conversion', conversionParams);
    window.setTimeout(complete, 2000);
  };

  window.reportGoogleAdsEvent = function (eventName, params) {
    if (eventName && typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  };

  // window.reportPromoCouponConversion = function (onComplete) {
  //   window.reportGoogleAdsConversion(window.GOOGLE_ADS_CONVERSIONS.promoTrigger, onComplete);
  // };
})();

(function () {
  if (!window.IS_PRODUCTION) return;

  window.META_PIXEL_EVENTS = {
    // promoTrigger: 'PromoCouponTrigger',
    // modalUnlock: 'ModalUnlockNow',
    couponCheckout: 'CouponReserveNow',
    reserveYourDrive: 'ReserveYourDrive',
    joinFbGroup: 'Join FB Group',
    joinFbGroupWithEmail: 'Join FB Group (+ Email)'
  };

  window.reportMetaPixelEvent = function (eventName, params) {
    if (eventName && typeof fbq === 'function') {
      fbq('trackCustom', eventName, params || {});
    }
  };

  window.reportMetaStandardEvent = function (eventName, params) {
    if (eventName && typeof fbq === 'function') {
      fbq('track', eventName, params || {});
    }
  };

  var reportedTakeDriveReservations = Object.create(null);
  var reportedGoogleTakeDriveReservations = Object.create(null);
  var reportedRokuTakeDriveReservations = Object.create(null);

  // Use form-option codes, not translated labels or option order.
  window.isQualifiedTakeDriveReservation = function (payload, market) {
    var eligibleBudgets = {
      us: ['usd_2000_4000', 'usd_4000_6000', 'usd_6000_8000', 'usd_over_8000'],
      eu: ['eur_1500_3500', 'eur_3500_5000', 'eur_5000_7000', 'eur_over_7000'],
      uk: ['gbp_1500_3000', 'gbp_3000_4500', 'gbp_4500_6000', 'gbp_over_6000']
    };
    return Boolean(payload && eligibleBudgets[market] &&
      String(payload.selfPayComfort || '').trim() === market + '_yes_out_of_pocket' &&
      eligibleBudgets[market].indexOf(String(payload.purchaseBudget || '').trim()) !== -1);
  };

  window.reportTakeDriveReservation = function (payload, reservationId) {
    var market = typeof window.getMarketCode === 'function'
      ? String(window.getMarketCode() || '').toLowerCase()
      : '';
    if (market !== 'us' && market !== 'eu' && market !== 'uk') return;
    if (!window.isQualifiedTakeDriveReservation(payload, market)) return;

    var selfPay = String(payload.selfPayComfort || '').trim();
    var timeline = String(payload.purchaseTimeline || '').trim();
    var budget = String(payload.purchaseBudget || '').trim();
    var value;
    if (selfPay === market + '_no_outside_budget') {
      return;
    } else if (selfPay === market + '_yes_out_of_pocket') {
      var budgetGroups = {
        us: {
          low: ['usd_2000_4000'],
          high: ['usd_4000_6000', 'usd_6000_8000', 'usd_over_8000']
        },
        eu: {
          low: ['eur_1500_3500'],
          high: ['eur_3500_5000', 'eur_5000_7000', 'eur_over_7000']
        },
        uk: {
          low: ['gbp_1500_3000'],
          high: ['gbp_3000_4500', 'gbp_4500_6000', 'gbp_over_6000']
        }
      };
      var isHighBudget = budgetGroups[market].high.indexOf(budget) !== -1;
      if (!isHighBudget && budgetGroups[market].low.indexOf(budget) === -1) return;
      if (timeline === 'within_1_month' || timeline === 'within_1_3_months') {
        value = isHighBudget ? 100 : 30;
      } else if (timeline === 'over_3_months' || timeline === 'no_specific_timeline') {
        value = isHighBudget ? 60 : 10;
      } else {
        return;
      }
    } else {
      return;
    }

    var leadKey = String(reservationId || '').trim();
    if (window.IS_US_PRODUCTION && market === 'us' && typeof window.rkp === 'function' &&
        !(leadKey && reportedRokuTakeDriveReservations[leadKey])) {
      window.rkp('event', 'LEAD', {
        content_name: 'Reserve Your Drive',
        value: value,
        currency: 'USD',
        event_id: leadKey ? 'take-drive-' + leadKey : undefined
      });
      if (leadKey) reportedRokuTakeDriveReservations[leadKey] = true;
    }
    var googleCompletion;
    // US Google Ads uses the same qualification values as the Meta event.
    // Keep the two providers independent: Meta may be unavailable or blocked.
    if (market === 'us' && typeof window.reportGoogleAdsConversion === 'function' &&
        !(leadKey && reportedGoogleTakeDriveReservations[leadKey])) {
      var sendTo = (window.GOOGLE_ADS_CONVERSIONS || {}).reserveYourDrive;
      if (sendTo && typeof window.gtag === 'function') {
        googleCompletion = new Promise(function (resolve) {
          window.reportGoogleAdsConversion(sendTo, resolve, {
            value: value,
            currency: 'USD',
            transaction_id: leadKey || undefined
          });
        });
        if (leadKey) reportedGoogleTakeDriveReservations[leadKey] = true;
      }
    }

    if (typeof fbq !== 'function') return googleCompletion;
    if (leadKey && reportedTakeDriveReservations[leadKey]) return googleCompletion;
    window.reportMetaPixelEvent(window.META_PIXEL_EVENTS.reserveYourDrive, {
      content_name: 'Test Drive',
      value: value,
      currency: market === 'us' ? 'USD' : 'EUR'
    });
    if (leadKey) reportedTakeDriveReservations[leadKey] = true;
    return googleCompletion;
  };
})();
